/* eslint-disable radix */
import React, { useState, useEffect } from 'react'
import { Query } from 'react-apollo'
import {
  Div, Button,
} from 'konsys-ui'
import ReactHtmlParser from 'react-html-parser'
import { Row, Col } from 'antd'
import {
  InputAmount, DivAmount, CheckboxLabel, LabelAmount, DivCenter,
  CheckboxSpan, DescriptionContent, Checkbox, InputAmountTest,
  DivInput,
} from './styled'
import NotchedContainer from '../../../../../components/common/notched-containner'
import PriceDetails from '../../../../../images/icon/Price-detailsIcon.png'
import PriceList from '../../../../../images/icon/Price-listIcon.png'
import PriceCalculateTable from '../common/price-calculate-table'
import OrderTypeSelect from '../common/order-type-select'
import { GET_TAX_RATE, PRICE_CALCULATOR_QUANTITY, GET_PRICE_NOTE } from '../../../../../constants/graph/query'


const mockTable = [{
  quantity: 1,
  totalCost: 11100.00,
  totalRepeatCost: 11100.00,
}, {
  quantity: 500,
  totalCost: 45.00,
  totalRepeatCost: 25.00,
}, {
  quantity: 1000,
  totalCost: 35.00,
  totalRepeatCost: 22.00,
}, {
  quantity: 1500,
  totalCost: 32.00,
  totalRepeatCost: 20.00,
}, {
  quantity: 2000,
  totalCost: 30.00,
  totalRepeatCost: 18.00,
}, {
  quantity: 3000,
  totalCost: 28.00,
  totalRepeatCost: 17.00,
}, {
  quantity: 4000,
  totalCost: 27.00,
  totalRepeatCost: 16.50,
}, {
  quantity: 6000,
  totalCost: 26.00,
  totalRepeatCost: 16.00,
}, {
  quantity: 7000,
  totalCost: 24.00,
  totalRepeatCost: 15.50,
}, {
  quantity: 8000,
  totalCost: 22.00,
  totalRepeatCost: 14.00,
}, {
  quantity: 9000,
  totalCost: 19.00,
  totalRepeatCost: 13.00,
}, {
  quantity: 10000,
  totalCost: 18.00,
  totalRepeatCost: 11.50,
}]
const quantity = [1, 500, 1000, 1500, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000]
const TablePrice = ({
  totalCost,
  formValues,
  setFormValues,
  setDisabledRequestQuot,
}) => {
  const [orderType, setOrderType] = useState(formValues.productionType || 'newOrder')
  const [dataTable, setDataTable] = useState([])
  const [amountProduction, setAmountProduction] = useState(formValues.amountProduction || 500)
  const [totalCostDefault, setTotalCostDefault] = useState(null)
  const [previousAmountProduction, setPreviousAmountProduction] = useState(parseInt(formValues.minimumManufacture) || 0)
  const [firstTimeLoad, setFirstTimeLoad] = useState(true)
  const [disabledOrderType, setDisabledOrderType] = useState(false)

  const handleCalulate = async (amount, refetch) => {
    setDisabledRequestQuot(true)
    setDisabledOrderType(true)
    const part = formValues.partData.map((item, index) => ({
      order: index + 1,
      packagePartId: item.packagePartId,
      unit: item.measurementUnit.key,
      operator: Object.values(item.sizeList).map(x => (parseFloat(x))),
      printSizeWidth: 0.0,
      printSizeLength: 0.0,
      paper: {
        paperId: item.paper.paperId,
        thickness: parseFloat(item.paper.selectedThickness),
      },
      printing: item.printing.side && {
        side: item.printing.printingType,
        printingBasicColorId: item.printing.printingBasicColorId,
        printingExtraColorId: item.printing.printingExtraColorId.filter(x => x.printingExtraColorId).map(x => x.printingExtraColorId),
      },
      coating: {
        coatingIdFront: item.coating.side === 1 || item.coating.side === 2 ? item.coating.coatingFrontId : null,
        coatingIdBehind: item.coating.side === -1 || item.coating.side === 2 ? item.coating.coatingBackId : null,
      },
      spotUV: {
        spotUVIdFront: item.spotUV.spotUVFrontId,
        spotUVIdBehind: item.spotUV.spotUVBackId,
      },
      embossing: item.embossing.map((x, i) => ({
        order: i + 1,
        width: parseFloat(x.width),
        length: parseFloat(x.lengths),
        unit: item.measurementUnit.key,
      })),
      foiling: {
        foilingId: item.foilingId !== 0 ? item.foilingId : null,
        foilingPart: item.foiling.map((x, i) => ({
          order: i + 1,
          width: parseFloat(x.width),
          length: parseFloat(x.lengths),
          unit: item.measurementUnit.key,
        })),
      },
      dieCut: item.isDieCut,
      plasticWindow: item.plasticWindow.map((x, i) => ({
        order: i + 1,
        width: parseFloat(x.width),
        length: parseFloat(x.lengths),
        thickness: x.thickness,
        unit: item.measurementUnit.key,
      })),
      gluingId: item.gluing ? item.gluing.gluingId : item.gluingId ? item.gluingId : null,
      additionalServiceId: (item.additionalServiceId && item.additionalServiceId.length > 0) ? item.additionalServiceId.map(x => x.additionalServiceId || x.value) || [] : item.additionalService.map(x => x.additionalServiceId || x.value) || [],
    }))
    const input = {
      part,
      quantity: parseInt(amount),
    }
    await refetch({
      input,
    }).then((res) => {
      if (res && res.data.priceCalculatorQuantity.success) {
        const tmpForm = formValues
        setFormValues({
          ...tmpForm,
          amountProduction: parseInt(amount),
          partData: formValues.partData,
          partDetail: res.data.priceCalculatorQuantity.partDetail,
          pricePerPiece: formValues.productionType === 'newOrder' ? Math.round(res.data.priceCalculatorQuantity.totalCost[0].totalCost * 100) / 100 : Math.round(res.data.priceCalculatorQuantity.totalCost[0].totalRepeatCost * 100) / 100,
          priceNewOrder: Math.round(res.data.priceCalculatorQuantity.totalCost[0].totalCost * 100) / 100,
          priceRepeat: Math.round(res.data.priceCalculatorQuantity.totalCost[0].totalRepeatCost * 100) / 100,
          amountTotalCost: res.data.priceCalculatorQuantity.totalCost[0],
        })
        localStorage.removeItem('package')
        localStorage.setItem('package', JSON.stringify(tmpForm))
      }
      setDisabledRequestQuot(false)
      setDisabledOrderType(false)
    }).catch((e) => {
      setDisabledRequestQuot(false)
      setDisabledOrderType(false)
      console.log('error', e)
    })
  }

  const handleChange = (e, refetch) => {
    setDisabledOrderType(true)
    const { value } = e.target
    const result = Math.round(parseInt(value) / 100) * 100
    if (parseInt(amountProduction) + 1 === parseInt(value)) {
      setAmountProduction(result + formValues.incrementalSteps)
    } else if (parseInt(amountProduction) - 1 === parseInt(value)) {
      setAmountProduction(result - formValues.incrementalSteps)
    } else {
      setAmountProduction(parseInt(value))
    }
  }

  const handleBlur = (e, refetch) => {
    const { value } = e.target
    const tmpForm = formValues
    setDisabledOrderType(true)
    if (parseInt(previousAmountProduction) === parseInt(value)) {
      setPreviousAmountProduction(parseInt(value))
      setDisabledOrderType(false)
      return
    }
    if (parseInt(value) < formValues.minimumManufacture) {
      setFormValues({ ...tmpForm, amountProduction: formValues.minimumManufacture })
      setAmountProduction(parseInt(formValues.minimumManufacture))
      setPreviousAmountProduction(parseInt(formValues.minimumManufacture))
      handleCalulate(parseInt(formValues.minimumManufacture), refetch)
    } else if (parseInt(value) === formValues.minimumManufacture) {
      setFormValues({ ...tmpForm, amountProduction: formValues.minimumManufacture })
      setAmountProduction(parseInt(formValues.minimumManufacture))
      setPreviousAmountProduction(parseInt(formValues.minimumManufacture))
      handleCalulate(parseInt(formValues.minimumManufacture), refetch)
    } else if (parseInt(value) >= 1000000000) {
      setFormValues({ ...tmpForm, amountProduction: 1000000000 })
      setAmountProduction(1000000000)
      setPreviousAmountProduction(1000000000)
      handleCalulate(1000000000, refetch)
    } else if (value === '') {
      setFormValues({ ...tmpForm, amountProduction: formValues.minimumManufacture })
      setAmountProduction(parseInt(formValues.minimumManufacture))
      setPreviousAmountProduction(parseInt(formValues.minimumManufacture))
      handleCalulate(parseInt(formValues.minimumManufacture), refetch)
    } else {
      const length = (1000000000 - formValues.minimumManufacture) / formValues.incrementalSteps
      const arr = Array.from({ length }, (v, i) => formValues.minimumManufacture + i * formValues.incrementalSteps)
      setFormValues({ ...tmpForm, amountProduction: parseInt(arr.find(t => t >= parseInt(value))) })
      setAmountProduction(parseInt(arr.find(t => t >= parseInt(value))))
      setPreviousAmountProduction(parseInt(arr.find(t => t >= parseInt(value))))
      handleCalulate(parseInt(arr.find(t => t >= parseInt(value))), refetch)
    }
  }

  useEffect(() => {
    const indexMinimum = quantity.reverse().find(e => e <= formValues.minimumManufacture)
    const index = quantity.reverse().indexOf(indexMinimum)
    if (totalCostDefault) {
      setDataTable([totalCostDefault, ...totalCost.slice(index + 1, totalCost.length)])
    } else {
      setDataTable(totalCost.slice(index, totalCost.length))
    }
  }, [formValues.incrementalSteps, formValues.minimumManufacture, totalCostDefault])

  const handleChangeWithHoldingTax = (e) => {
    const tmpForm = formValues
    setFormValues({ ...tmpForm, widthHoldingTax: e.target.checked })
  }

  const handleChangeProductType = (e) => {
    setOrderType(e)
    const tmpForm = formValues
    setFormValues({ ...tmpForm, productionType: e })
  }

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 375)
  const [isMobileXL, setIsMobileXL] = useState(window.innerWidth <= 570)

  const screenSizeHandler = () => setIsMobileView(window.innerWidth <= 375)
  const screenSizeHandler2 = () => setIsMobileXL(window.innerWidth <= 570)

  useEffect(() => {
    window.addEventListener('resize', screenSizeHandler)
    window.addEventListener('resize', screenSizeHandler2)
    return () => {
      window.removeEventListener('resize', screenSizeHandler)
      window.removeEventListener('resize', screenSizeHandler2)
    }
  }, [])

  return (
    <NotchedContainer
      title='ตารางราคา'
      titleIcon={PriceList}
    >
      <Div style={{ width: '100%' }}>
        <PriceCalculateTable
          data={dataTable}
          orderType={orderType}
        />
        <Div style={{ display: 'flex', paddingTop: '14px' }}>
          <Query
            query={GET_PRICE_NOTE}
            notifyOnNetworkStatusChange
          >
            {
              ({ loading, data }) => {
                if (loading) return <Div></Div>
                return (
                  <React.Fragment>
                    {
                      data.priceNote && data.priceNote.description && <DescriptionContent moreStyle={{ lineBreak: 'anywhere' }}>
                        {ReactHtmlParser(data.priceNote.description)}
                    </DescriptionContent>
                    }
                  </React.Fragment>
                )
              }
            }
          </Query>
        </Div>
        <Div style={{ paddingTop: '14px' }}>
          <Row gutter={16}>
            <Col xs={24} sm={14} md={12} span={16}>
              <OrderTypeSelect
                data={orderType}
                onChange={handleChangeProductType}
                disabled={disabledOrderType}
              />
              {/* <span>formValues.isBack</span> { formValues.isBack ? 'true' : 'false' } <br />
              <span>firstTimeLoad</span> { firstTimeLoad ? 'true' : 'false' } <br />
              <span>formValues.minimumManufacture</span> { formValues.minimumManufacture } <br />
              <span>formValues.amountProduction</span> { formValues.amountProduction } <br />
              <span>formValues.amountTotalCost</span> { formValues.amountTotalCost ? 'true' : 'false' } <br />
              <span>formValues.amountTotalCost.Quantity</span> { formValues.amountTotalCost ? formValues.amountTotalCost.quantity : 'false' } <br />
              <span>formValues.productionType</span> { formValues.productionType }
              <span>check quantity</span> { formValues.amountTotalCost && !formValues.isBack ? parseInt(formValues.amountProduction) : formValues.isBack ? parseInt(formValues.amountProduction) : parseInt(formValues.minimumManufacture) } */}
            </Col>
            <Col xs={24} sm={14} md={12} span={16}>
              <Div
                style={{
                  width: '100%',
                  paddingTop: isMobileXL ? '8px' : '8px',
                  paddingLeft: isMobileXL ? '0px' : '0px',
                }}
                >
                  <DivAmount>
                    <LabelAmount>{'ระบุจำนวนการผลิต'}</LabelAmount>
                    <DivCenter style={{ padding: '16px' }}>
                      <Query
                        query={PRICE_CALCULATOR_QUANTITY}
                        fetchPolicy='network-only'
                        notifyOnNetworkStatusChange
                        variables={firstTimeLoad && {
                          input: {
                            part: formValues.partData.map((item, index) => ({
                              order: index + 1,
                              packagePartId: item.packagePartId,
                              unit: item.measurementUnit.key,
                              operator: Object.values(item.sizeList).map(x => (parseFloat(x))),
                              printSizeWidth: 0.0,
                              printSizeLength: 0.0,
                              paper: {
                                paperId: item.paper.paperId,
                                thickness: parseFloat(item.paper.selectedThickness),
                              },
                              printing: item.printing.side && {
                                side: item.printing.printingType,
                                printingBasicColorId: item.printing.printingBasicColorId,
                                printingExtraColorId: item.printing.printingExtraColorId.filter(x => x.printingExtraColorId).map(x => x.printingExtraColorId),
                              },
                              coating: {
                                coatingIdFront: item.coating.coatingFrontId,
                                coatingIdBehind: item.coating.coatingBackId,
                              },
                              spotUV: {
                                spotUVIdFront: item.spotUV.spotUVFrontId,
                                spotUVIdBehind: item.spotUV.spotUVBackId,
                              },
                              embossing: item.embossing.map((x, i) => ({
                                order: i + 1,
                                width: parseFloat(x.width),
                                length: parseFloat(x.lengths),
                                unit: item.measurementUnit.key,
                              })),
                              foiling: {
                                foilingId: item.foilingId !== 0 ? item.foilingId : null,
                                foilingPart: item.foiling.map((x, i) => ({
                                  order: i + 1,
                                  width: parseFloat(x.width),
                                  length: parseFloat(x.lengths),
                                  unit: item.measurementUnit.key,
                                })),
                              },
                              dieCut: item.isDieCut,
                              plasticWindow: item.plasticWindow.map((x, i) => ({
                                order: i + 1,
                                width: parseFloat(x.width),
                                length: parseFloat(x.lengths),
                                thickness: x.thickness,
                                unit: item.measurementUnit.key,
                              })),
                              gluingId: item.gluing ? item.gluing.gluingId : item.gluingId ? item.gluingId : null,
                              additionalServiceId: (item.additionalServiceId && item.additionalServiceId.length > 0) ? item.additionalServiceId.map(x => x.additionalServiceId || x.value) || [] : item.additionalService.map(x => x.additionalServiceId || x.value) || [],
                            })),
                            quantity: formValues.amountTotalCost && !formValues.isBack ? parseInt(formValues.amountProduction) : formValues.isBack ? parseInt(formValues.amountProduction) : parseInt(formValues.minimumManufacture),
                          },
                        }}
                        onCompleted={(data) => {
                          setDisabledRequestQuot(true)
                          setDisabledOrderType(true)
                          if (!formValues.isBack && data) {
                            if (firstTimeLoad && data.priceCalculatorQuantity.totalCost[0].quantity === formValues.minimumManufacture) {
                              setTotalCostDefault(data.priceCalculatorQuantity.totalCost[0])
                              const tmpForm = formValues
                              setFormValues({
                                ...tmpForm,
                                partData: formValues.partData,
                                partDetail: data.priceCalculatorQuantity.partDetail,
                                pricePerPiece: formValues.productionType === 'newOrder' ? Math.round(data.priceCalculatorQuantity.totalCost[0].totalCost * 100) / 100 : Math.round(data.priceCalculatorQuantity.totalCost[0].totalRepeatCost * 100) / 100,
                                priceNewOrder: Math.round(data.priceCalculatorQuantity.totalCost[0].totalCost * 100) / 100,
                                priceRepeat: Math.round(data.priceCalculatorQuantity.totalCost[0].totalRepeatCost * 100) / 100,
                                minimumTotalCost: data.priceCalculatorQuantity.totalCost[0],
                              })
                              localStorage.removeItem('package')
                              localStorage.setItem('package', JSON.stringify(tmpForm))
                              setDisabledRequestQuot(false)
                              setDisabledOrderType(false)
                            } else if (!firstTimeLoad && data.priceCalculatorQuantity.totalCost[0].quantity === formValues.amountProduction) {
                              const tmpForm = formValues
                              setFormValues({
                                ...tmpForm,
                                partData: formValues.partData,
                                partDetail: data.priceCalculatorQuantity.partDetail,
                                pricePerPiece: formValues.productionType === 'newOrder' ? Math.round(data.priceCalculatorQuantity.totalCost[0].totalCost * 100) / 100 : Math.round(data.priceCalculatorQuantity.totalCost[0].totalRepeatCost * 100) / 100,
                                priceNewOrder: Math.round(data.priceCalculatorQuantity.totalCost[0].totalCost * 100) / 100,
                                priceRepeat: Math.round(data.priceCalculatorQuantity.totalCost[0].totalRepeatCost * 100) / 100,
                                amountTotalCost: data.priceCalculatorQuantity.totalCost[0],
                              })
                              localStorage.removeItem('package')
                              localStorage.setItem('package', JSON.stringify(tmpForm))
                              setDisabledRequestQuot(false)
                              setDisabledOrderType(false)
                            } else if (formValues.amountTotalCost && !firstTimeLoad && data.priceCalculatorQuantity.totalCost[0].quantity !== formValues.amountProduction) {
                              const tmpForm = formValues
                              setFormValues({
                                ...tmpForm,
                                partData: formValues.partData,
                                partDetail: data.priceCalculatorQuantity.partDetail,
                                pricePerPiece: formValues.productionType === 'newOrder' ? Math.round(formValues.amountTotalCost.totalCost * 100) / 100 : Math.round(formValues.amountTotalCost.totalCost.totalRepeatCost * 100) / 100,
                                priceNewOrder: Math.round(formValues.amountTotalCost.totalCost * 100) / 100,
                                priceRepeat: Math.round(formValues.amountTotalCost.totalCost * 100) / 100,
                              })
                              localStorage.removeItem('package')
                              localStorage.setItem('package', JSON.stringify(tmpForm))
                              setDisabledRequestQuot(false)
                              setDisabledOrderType(false)
                            } else if (formValues.amountTotalCost && !firstTimeLoad && data.priceCalculatorQuantity.totalCost[0].quantity === formValues.amountProduction) {
                              const tmpForm = formValues
                              setFormValues({
                                ...tmpForm,
                                partData: formValues.partData,
                                partDetail: data.priceCalculatorQuantity.partDetail,
                                pricePerPiece: formValues.productionType === 'newOrder' ? Math.round(formValues.amountTotalCost.totalCost * 100) / 100 : Math.round(formValues.amountTotalCost.totalCost.totalRepeatCost * 100) / 100,
                                priceNewOrder: Math.round(formValues.amountTotalCost.totalCost * 100) / 100,
                                priceRepeat: Math.round(formValues.amountTotalCost.totalCost * 100) / 100,
                              })
                              localStorage.removeItem('package')
                              localStorage.setItem('package', JSON.stringify(tmpForm))
                              setDisabledRequestQuot(false)
                              setDisabledOrderType(false)
                            } else {
                              const tmpForm = formValues
                              setFormValues({
                                ...tmpForm,
                                partData: formValues.partData,
                                partDetail: data.priceCalculatorQuantity.partDetail,
                                pricePerPiece: formValues.productionType === 'newOrder' ? Math.round(data.priceCalculatorQuantity.totalCost[0].totalCost * 100) / 100 : Math.round(data.priceCalculatorQuantity.totalCost[0].totalRepeatCost * 100) / 100,
                                priceNewOrder: Math.round(data.priceCalculatorQuantity.totalCost[0].totalCost * 100) / 100,
                                priceRepeat: Math.round(data.priceCalculatorQuantity.totalCost[0].totalRepeatCost * 100) / 100,
                              })
                              localStorage.removeItem('package')
                              localStorage.setItem('package', JSON.stringify(tmpForm))
                              setDisabledRequestQuot(false)
                              setDisabledOrderType(false)
                            }
                          } else if (formValues.isBack && data) {
                            if (firstTimeLoad && data.priceCalculatorQuantity.totalCost[0].quantity === formValues.minimumManufacture) {
                              setTotalCostDefault(formValues.minimumTotalCost)
                              const tmpForm = formValues
                              setFormValues({
                                ...tmpForm,
                                partData: formValues.partData,
                                partDetail: data.priceCalculatorQuantity.partDetail,
                                pricePerPiece: formValues.productionType === 'newOrder' ? Math.round(data.priceCalculatorQuantity.totalCost[0].totalCost * 100) / 100 : Math.round(data.priceCalculatorQuantity.totalCost[0].totalRepeatCost * 100) / 100,
                                priceNewOrder: Math.round(data.priceCalculatorQuantity.totalCost[0].totalCost * 100) / 100,
                                priceRepeat: Math.round(data.priceCalculatorQuantity.totalCost[0].totalRepeatCost * 100) / 100,
                              })
                              localStorage.removeItem('package')
                              localStorage.setItem('package', JSON.stringify(tmpForm))
                              setDisabledRequestQuot(false)
                              setDisabledOrderType(false)
                            } else if (!firstTimeLoad && data.priceCalculatorQuantity.totalCost[0].quantity === formValues.amountProduction) {
                              setTotalCostDefault(formValues.minimumTotalCost)
                              const tmpForm = formValues
                              setFormValues({
                                ...tmpForm,
                                partData: formValues.partData,
                                partDetail: data.priceCalculatorQuantity.partDetail,
                                pricePerPiece: formValues.productionType === 'newOrder' ? Math.round(data.priceCalculatorQuantity.totalCost[0].totalCost * 100) / 100 : Math.round(data.priceCalculatorQuantity.totalCost[0].totalRepeatCost * 100) / 100,
                                priceNewOrder: Math.round(data.priceCalculatorQuantity.totalCost[0].totalCost * 100) / 100,
                                priceRepeat: Math.round(data.priceCalculatorQuantity.totalCost[0].totalRepeatCost * 100) / 100,
                              })
                              localStorage.removeItem('package')
                              localStorage.setItem('package', JSON.stringify(tmpForm))
                              setDisabledRequestQuot(false)
                              setDisabledOrderType(false)
                            } else {
                              setTotalCostDefault(formValues.minimumTotalCost)
                              const tmpForm = formValues
                              setFormValues({
                                ...tmpForm,
                                partData: formValues.partData,
                                partDetail: data.priceCalculatorQuantity.partDetail,
                                pricePerPiece: formValues.productionType === 'newOrder' ? Math.round(data.priceCalculatorQuantity.totalCost[0].totalCost * 100) / 100 : Math.round(data.priceCalculatorQuantity.totalCost[0].totalRepeatCost * 100) / 100,
                                priceNewOrder: Math.round(data.priceCalculatorQuantity.totalCost[0].totalCost * 100) / 100,
                                priceRepeat: Math.round(data.priceCalculatorQuantity.totalCost[0].totalRepeatCost * 100) / 100,
                              })
                              localStorage.removeItem('package')
                              localStorage.setItem('package', JSON.stringify(tmpForm))
                              setDisabledRequestQuot(false)
                              setDisabledOrderType(false)
                            }
                          }
                          setFirstTimeLoad(false)
                          setDisabledRequestQuot(false)
                          setDisabledOrderType(false)
                        }}
                      >
                        {
                          ({ refetch }) => (
                            <DivInput>
                              <InputAmountTest
                                type="number"
                                value={amountProduction}
                                // suffix="ชิ้น"
                                suffix={<span>ชิ้น</span>}
                                onChange={e => handleChange(e, refetch)}
                                onBlur={e => handleBlur(e, refetch)}
                                min={formValues.minimumManufacture}
                                pattern="[0-9]"
                                max={1000000000}
                              />
                            </DivInput>
                          )
                        }
                      </Query>
                    </DivCenter>
                  </DivAmount>
                  <DivCenter style={{ paddingTop: '16px' }}>
                    <Query
                      query={GET_TAX_RATE}
                    >
                      {
                        ({ data }) => (
                          <Checkbox onChange={handleChangeWithHoldingTax} style={{ lineHeight: '1.2' }}><CheckboxLabel>ต้องการดำเนินการหักภาษี ณ ที่จ่าย {data.taxRate && data.taxRate.withHoldingTaxRate} % </CheckboxLabel><br/><CheckboxSpan>ลูกค้าจะต้องส่งหนังสือรับรองการหัก ณ ที่จ่ายตัวจริงมาให้ หลังการชำระเงิน</CheckboxSpan></Checkbox>
                        )
                      }
                    </Query>
                  </DivCenter>
                </Div>
            </Col>
          </Row>
        </Div>
      </Div>
    </NotchedContainer>
  )
}

export default TablePrice



// WEBPACK FOOTER //
// ./src/pages/package-page/detail/components/table-price/index.jsx